import React from 'react';
import ReactDOM from 'react-dom';
import {browserHistory, Router} from 'react-router';
import settings from '../config/settings';
import routing from './shared/routing';
import {applyMiddleware, createStore} from 'redux';
import thunkMiddleware from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
import reducers from './shared/reducers';
import sagas from './shared/sagas';
import { createLogger } from 'redux-logger';
import {routerMiddleware, syncHistoryWithStore} from 'react-router-redux';
import createRavenMiddleware from 'raven-for-redux';
import reduxCatch from 'redux-catch';
import {Provider} from 'react-redux';
import UserSession from './shared/auth/UserSession';
import Raven from 'raven-js';

require('./styles/main.scss');

// Export React so the dev tools can find it
if (window === window.top) {
  window.React = React;
}

UserSession.setClientAuthCookie();

const reduxLoggerMiddleware = createLogger();
const sagaMiddleware = createSagaMiddleware();

let initialState = null;
if (window.__STATE__) {
  initialState = window.__STATE__;
}

// create a store with middlewares
const reduxMiddleware = [thunkMiddleware,
  sagaMiddleware,
  routerMiddleware(browserHistory)
];

if (__DEVCLIENT__) {
  //turn off redux logs in production
  reduxMiddleware.push(reduxLoggerMiddleware);
}
if (settings.sentry && settings.sentry.publicDSN) {
  const {sentry} = settings;
  Raven.config(sentry.publicDSN, {release: sentry.release, environment: sentry.environment}).install();
  reduxMiddleware.unshift(createRavenMiddleware(Raven));
  reduxMiddleware.push(reduxCatch(error => Raven.captureException(error)));
}
const store = createStore(
  reducers,
  initialState,
  applyMiddleware(...reduxMiddleware));

const history = syncHistoryWithStore(browserHistory, store);
sagaMiddleware.run(sagas);

ReactDOM.hydrate(
  <Provider store={store}>
    <Router history={history}>
      {routing(store)}
    </Router>
  </Provider>,
  document.getElementById('app')
);



// WEBPACK FOOTER //
// ./app.client.js